import React, { Component } from 'react';

import '../css/nuevos.css'

import prod1 from '../img/taladro-black-decker.png'
import prod2 from '../img/foco-sylvania.png'

class Nuevos extends Component {
  render() {
    return (
      <div className="container mt-4">

        <div className="row no-gutters">

          <div className="prod1 row animated fadeInLeft col-lg-6 align-items-center no-gutters">
            <div className="vineta">Nuevo</div>
            <div className="efectohover textoprod col-8 pl-lg-5 pl-4">
              Renueva tus <span className="textoprod-gr">Herramientas</span>
            </div>
            <div className="col-4 ml-lg-auto ml-n5"><img src={prod1} alt=""/></div>
          </div>

          <div className="prod2 row animated fadeInRight col-lg-6 align-items-center no-gutters">
            <div className="vineta">Nuevo</div>
            <div className="efectohover textoprod col-8 pl-lg-5 pl-4">
              Accesorios <span className="textoprod-gr">Eléctricos</span>
            </div>
            <div className="col-4 ml-lg-auto ml-n5"><img src={prod2} alt=""/></div>
          </div>

        </div>

      </div>
    )
  }
}

export default Nuevos;
